import styled from 'styled-components'

export const Answer = styled.div`
  padding: 5px;
  padding-left: 20px;
  border-radius: 4px;
`
